/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import { Mapper, PresenterType } from '../../../types';
import { personDropdownExtraInfo } from '../../../utils';

const mapper: Mapper = {
  contact: {
    presenter: PresenterType.DropdownFormPresenter,
    extraInfo: {
      ...personDropdownExtraInfo,
      initialValue: getters => [
        {
          id: getters.currentUser.id,
          label: getters.currentUser.presentName,
          role: getters.currentUser.role,
          value: getters.currentUser.email,
        },
      ],
    },
  },
  programEditors: {
    presenter: PresenterType.DropdownFormPresenter,
    renderInfo: {
      presenterAttributes: {
        multiple: true,
      },
    },
    extraInfo: {
      ...personDropdownExtraInfo,
    },
  },
  programOwners: {
    presenter: PresenterType.DropdownFormPresenter,
    renderInfo: {
      presenterAttributes: {
        multiple: true,
      },
    },
    extraInfo: {
      ...personDropdownExtraInfo,
    },
  },
  programReaders: {
    presenter: PresenterType.DropdownFormPresenter,
    renderInfo: {
      presenterAttributes: {
        multiple: true,
      },
    },
    extraInfo: {
      ...personDropdownExtraInfo,
    },
  },
};

export default {
  mapper,
};
